import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircle from "../../../images/check_circle.svg";
import Pin from "../../../images/code.png";

import FiEdit from "../../../images/code_vector.png";
import FiEye from "../../../images/arrow_right.png";

function CodingDialogue(props) {
  const title = props.title;
  const dialogueText = props.text;
  const handleSelectCodingQuestion = props.handleSelectCodingQuestion;
  const open = props.open;
  const showNewDialogue = props.showNewDialogue && props.showNewDialogue;
  const isDraft = props.isDraft && props.isDraft;
  const handleSelectAllQuestions = props.handleSelectAllQuestions && props.handleSelectAllQuestions;
  const closeDialogue = props.closeDialogue && props.closeDialogue;

  return !showNewDialogue ? (
    <Dialog
      PaperProps={{
        sx: {
          width: "370px",
          height: "224px",
        },
      }}
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {dialogueText}
        </DialogContentText>
      </DialogContent>
      <DialogActions  style={{ marginTop: "8px" }} className="mb-[20px]">
        <button className="teepee-button mr-[20px]" onClick={() => handleSelectCodingQuestion()}>
          Okay
        </button>
      </DialogActions>
    </Dialog>
  ) : 
  
  
  
  (
    <Dialog
      PaperProps={{
        sx: {
          width: "500px",
          borderRadius: "12px",
          padding: "36px",
          paddingTop: "0px",
        },
      }}
      open={open}
      aria-labelledby="task-saved-dialog-title"
    >


      <DialogTitle sx={{ position: "relative" }}>
        {/* Close Icon positioned on the upper right */}
        <button
          onClick={() => closeDialogue()}
          style={{
            position: "absolute",
            top: "16px",
            right: "-8px",
            background: "transparent",
            border: "none",
            cursor: "pointer",
          }}
          aria-label="close"
        >
          <CloseIcon style={{ fontSize: 20 }} />
        </button>
      </DialogTitle>


      <DialogContent className="text-center">
        <div className="flex justify-center">
          {/* Set image dimensions to 72px x 72px */}
          <img 
            src={isDraft ? Pin : CheckCircle} 
            alt="dialogue icon"
            style={{ width: "72px", height: "72px" }}
          />
        </div>
        <div className="text-[24px] leading-[2rem] font-bold text-gray-900 mb-[0.25rem]">
          {title}
        </div>
        <p className="text-[16px] leading-[1.5rem] tracking-[0.15px] text-[#49454F]">
          Would you like to generate a task with only coding questions, or include all question types?
        </p>
      </DialogContent>



      <DialogActions className="flex flex-col gap-y-[0.5rem]">
        <button
          onClick={() => handleSelectCodingQuestion()}
          className="teepee-button flex items-center gap-2 hover:bg-black w-full sm:w-[100%] justify-center"
        >
          <span className="flex items-center justify-center gap-2">
            <img src={FiEdit} alt="edit icon" />
            Yes, Only Coding Questions
          </span>
        </button>
        <button
          onClick={() => handleSelectAllQuestions()}
          className="teepee-back-button !ml-0 hover:bg-black hover:text-white w-full sm:w-[100%]"
        >
          <span className="flex items-center justify-center gap-2">
            <img src={FiEye} alt="eye icon" />
            No, Include All Question Types
          </span>
        </button>
      </DialogActions>


    </Dialog>
  );
}

export default CodingDialogue;
